import { extendTheme } from '@chakra-ui/react'

/**
 * This theme object can be changed and edited however you like. It's currently extending the default Chakra theme
 * (which itself is inspired by Tailwind CSS) with the values below.
 * Example usage of theme values: <Text color="brand.100" fontSize="6xl" fontWeight="bold">Boop</Text>
 */
const theme = {
    breakpoints: {
      sm: '30em',
      md: '49em',
      lg: '62em',
      xl: '80em',
      '2xl': '96em',
    },
    fonts: {
        heading: 'Noto Sans JP, sans-serif',
        body: 'Noto Sans JP, sans-serif',
    },
    fontSizes: {
      xs: "0.75rem",
      sm: "0.875rem",
      md: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.5rem",
      "3xl": "1.875rem",
      "4xl": "2.25rem",
      "5xl": "3rem",
      "6xl": "3.75rem",
      "7xl": "4.5rem",
      "8xl": "6rem",
      "9xl": "8rem",
    },
    lineHeights: {
        shorter: 1.83,
        short: 1.83,
        base: 1.86,
      },
    colors: {
        gray: {
            10: '#cbd0d3',
            30: '#f5f5f5',
            50: '#EBEBEB',
            100: '#d0d0d0',
            200: '#707070',
          },
        blue: '#0d3293',
        blue_hovered: '#091E55',
        red: '#c5211f'

    }
  }

export default extendTheme(theme)

export { theme }
